import { useTariffComponentMaintenanceVM } from "presentation/hook/TariffComponent/useTariffComponentMaintenanceVM";
import { useTariffComponentMaintenanceTracked } from "presentation/store/TariffComponent/TariffComponentMaintenanceProvider";
import { memo, useEffect } from "react";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import { TariffComponentDetailFormPanel } from "./TariffComponentDetailFormPanel";
import TariffComponentDetailTablePanel from "./TariffComponentDetailTablePanel";

const TariffComponentDetailMaintenance: React.FC = () => {
        const [tariffComponentState] = useTariffComponentMaintenanceTracked();
        const tariffComponentVM = useTariffComponentMaintenanceVM();
        const { isSliderOpen, } = tariffComponentState.detailState
        const currTariffComponentEntity = tariffComponentState.currentSelectedRow;
        useEffect(() => {
                currTariffComponentEntity?.id && tariffComponentVM.onSearchDetail(currTariffComponentEntity.id)
        }, [currTariffComponentEntity.id, tariffComponentVM])

        return <div className={`main-comp-wrapper${isSliderOpen ? '' : ' im-hide-side-form-draggable'}`}>
                <SliderPanel
                        isOpen={isSliderOpen}
                        leftSectionWidth={'100%'}
                        rightSectionWidth={'60%'}
                        draggable={true}
                        leftChildren={<div style={{ marginLeft: "15px" }}><TariffComponentDetailTablePanel /></div>}
                        rightChildren={<TariffComponentDetailFormPanel />} />
        </div>
}

export default memo(TariffComponentDetailMaintenance);